function validFiles (files, nombre) {

    //LISTA DE EXTENSIONES VÁLIDAS
    const validExt = [ 'application/pdf' ];
    let validos = [];

    //RECORREMOS LA LISTA DE ARCHIVOS
    files.forEach((file) => {
        //TOMAMOS LA EXTENSIÓN Y SI ES VÁLIDA LO AGREGAMOS A LA LISTA DE VÁLIDOS
        const ext = file.type;
        const size = file.size;

        const renombrado = new File([file], `${nombre}.${file.type.split('/')[1]}`, {
            type: file.type,
          });

        //SEGÚN EL ARCHIVO QUE SEA VALIDAMOS SU PESO
        if (nombre === "RepresentanteLegal" || nombre === "Referencia1" || nombre === "Referencia1"){
            //AQUÍ PERMITIMOS HASTA 10 MB
            if (validExt.includes(String(ext).toLowerCase()) && size < 10485760) validos.push(renombrado);
        }
        else{
            //AQUÍ PERMITIMOS HASTA 5
            if (validExt.includes(String(ext).toLowerCase()) && size < 5242880) validos.push(renombrado);
        }

        

    });
    
    return validos;
}

export default validFiles;